import { apiUrl } from 'src/constants/config';

/** Build the billing invoice WebSocket URL for a billing month (invoice group). */
export function buildBillingInvoiceWebSocketUrl(invoiceGroupId: string, accessToken: string): string {
  const httpBase = apiUrl.replace(/\/v1\/?$/, '');
  const wsBase = httpBase.replace(/^http/, 'ws');
  const encodedToken = encodeURIComponent(accessToken);
  return `${wsBase}/ws/b2b/billing/invoice_groups/${invoiceGroupId}/invoices/?token=${encodedToken}`;
}
